import request from '@/utils/request'

// 外部
export const getExternalTableData = params =>
  request.post('/customer-api/score/external/page', params)

// 内部
export const getInternalTableData = params =>
  request.post('/customer-api/score/internal/page', params)

export const saveGcr = params =>
  request.post('/customer-api/score/calculate/gcr', params)

// 外部弹窗
export const getDialogTableData = params =>
  request.post('/customer-api/score/adjustment/page', params)

export const saveDialogForm = params =>
  request.post('/customer-api/score/adjustment', params)
